"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardTags = void 0;
var vue_1 = require("vue");
var CardTag_1 = require("./CardTag");
exports.CardTags = vue_1.default.component('CardTags', {
    props: {
        tags: Array,
    },
    components: {
        CardTag: CardTag_1.CardTag,
    },
    template: "\n        <div class=\"card-tags\">\n            <CardTag v-for=\"(cardTag, index) in tags\" :key=\"index\" :index=\"index\" :type=\"cardTag\"/>\n        </div>\n    ",
});
//# sourceMappingURL=CardTags.js.map